import React from "react";
import { Dropdown } from "react-bootstrap";
import NavbarMenuToggle from "common/ui/NavbarMenuToggle";
import { i18n } from "i18n";

 
const LocalizationSelector: React.FC = () => {
    const languages: any = {
        en: { nativeName: 'English' },
        de: { nativeName: 'Deutsch' },
        es: { nativeName: 'Español'},
        fr: { nativeName: 'Français'},
        'pt-BR': { nativeName: 'Português'},
      };

    function onLanguageChange(language: string) {
        i18n.changeLanguage(language); 
        window.location.reload();
    }  
    
    return (
        <Dropdown className="merchant-picker">
            <Dropdown.Toggle as={NavbarMenuToggle} id="merchant-toggle" showArrow>
                {languages[i18n.language].nativeName}
            </Dropdown.Toggle>
            <Dropdown.Menu>
                {
                    Object.keys(languages)
                        .map((language) => 
                            <Dropdown.Item key={language} onClick={() => onLanguageChange(language)}>
                                {languages[language].nativeName}
                            </Dropdown.Item>
                        )
                }
            </Dropdown.Menu>
        </Dropdown>
        );
}

export default LocalizationSelector;